/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated.index'
import { Route as AuthenticatedPairRouteImport } from './routes/_authenticated.pair'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth.verify-email'
import { Route as AuthSignupRouteImport } from './routes/_auth.signup'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth.reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth.forgot-password'
import { Route as AuthenticatedTeamTeamSlugRouteImport } from './routes/_authenticated.team.$teamSlug'
import { Route as AuthenticatedTeamTeamSlugIndexRouteImport } from './routes/_authenticated.team.$teamSlug.index'
import { Route as AuthenticatedCanvasConnIdIndexRouteImport } from './routes/_authenticated.canvas.$connId.index'
import { Route as AuthenticatedTeamTeamSlugRecentsRouteImport } from './routes/_authenticated.team.$teamSlug.recents'
import { Route as AuthenticatedTeamTeamSlugPairRouteImport } from './routes/_authenticated.team.$teamSlug.pair'
import { Route as AuthenticatedTeamTeamSlugDraftsRouteImport } from './routes/_authenticated.team.$teamSlug.drafts'
import { Route as AuthenticatedCanvasConnIdQueryRouteImport } from './routes/_authenticated.canvas.$connId.query'
import { Route as AuthenticatedTeamTeamSlugCanvasIndexRouteImport } from './routes/_authenticated.team.$teamSlug.canvas.index'
import { Route as AuthenticatedTeamTeamSlugCanvasConnIdIndexRouteImport } from './routes/_authenticated.team.$teamSlug.canvas.$connId.index'
import { Route as AuthenticatedTeamTeamSlugCanvasConnIdQueryRouteImport } from './routes/_authenticated.team.$teamSlug.canvas.$connId.query'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPairRoute = AuthenticatedPairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedTeamTeamSlugRoute =
  AuthenticatedTeamTeamSlugRouteImport.update({
    id: '/team/$teamSlug',
    path: '/team/$teamSlug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTeamTeamSlugIndexRoute =
  AuthenticatedTeamTeamSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTeamTeamSlugRoute,
  } as any)
const AuthenticatedCanvasConnIdIndexRoute =
  AuthenticatedCanvasConnIdIndexRouteImport.update({
    id: '/canvas/$connId/',
    path: '/canvas/$connId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTeamTeamSlugRecentsRoute =
  AuthenticatedTeamTeamSlugRecentsRouteImport.update({
    id: '/recents',
    path: '/recents',
    getParentRoute: () => AuthenticatedTeamTeamSlugRoute,
  } as any)
const AuthenticatedTeamTeamSlugPairRoute =
  AuthenticatedTeamTeamSlugPairRouteImport.update({
    id: '/pair',
    path: '/pair',
    getParentRoute: () => AuthenticatedTeamTeamSlugRoute,
  } as any)
const AuthenticatedTeamTeamSlugDraftsRoute =
  AuthenticatedTeamTeamSlugDraftsRouteImport.update({
    id: '/drafts',
    path: '/drafts',
    getParentRoute: () => AuthenticatedTeamTeamSlugRoute,
  } as any)
const AuthenticatedCanvasConnIdQueryRoute =
  AuthenticatedCanvasConnIdQueryRouteImport.update({
    id: '/canvas/$connId/query',
    path: '/canvas/$connId/query',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTeamTeamSlugCanvasIndexRoute =
  AuthenticatedTeamTeamSlugCanvasIndexRouteImport.update({
    id: '/canvas/',
    path: '/canvas/',
    getParentRoute: () => AuthenticatedTeamTeamSlugRoute,
  } as any)
const AuthenticatedTeamTeamSlugCanvasConnIdIndexRoute =
  AuthenticatedTeamTeamSlugCanvasConnIdIndexRouteImport.update({
    id: '/canvas/$connId/',
    path: '/canvas/$connId/',
    getParentRoute: () => AuthenticatedTeamTeamSlugRoute,
  } as any)
const AuthenticatedTeamTeamSlugCanvasConnIdQueryRoute =
  AuthenticatedTeamTeamSlugCanvasConnIdQueryRouteImport.update({
    id: '/canvas/$connId/query',
    path: '/canvas/$connId/query',
    getParentRoute: () => AuthenticatedTeamTeamSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/pair': typeof AuthenticatedPairRoute
  '/': typeof AuthenticatedIndexRoute
  '/team/$teamSlug': typeof AuthenticatedTeamTeamSlugRouteWithChildren
  '/canvas/$connId/query': typeof AuthenticatedCanvasConnIdQueryRoute
  '/team/$teamSlug/drafts': typeof AuthenticatedTeamTeamSlugDraftsRoute
  '/team/$teamSlug/pair': typeof AuthenticatedTeamTeamSlugPairRoute
  '/team/$teamSlug/recents': typeof AuthenticatedTeamTeamSlugRecentsRoute
  '/canvas/$connId': typeof AuthenticatedCanvasConnIdIndexRoute
  '/team/$teamSlug/': typeof AuthenticatedTeamTeamSlugIndexRoute
  '/team/$teamSlug/canvas': typeof AuthenticatedTeamTeamSlugCanvasIndexRoute
  '/team/$teamSlug/canvas/$connId/query': typeof AuthenticatedTeamTeamSlugCanvasConnIdQueryRoute
  '/team/$teamSlug/canvas/$connId': typeof AuthenticatedTeamTeamSlugCanvasConnIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/pair': typeof AuthenticatedPairRoute
  '/': typeof AuthenticatedIndexRoute
  '/canvas/$connId/query': typeof AuthenticatedCanvasConnIdQueryRoute
  '/team/$teamSlug/drafts': typeof AuthenticatedTeamTeamSlugDraftsRoute
  '/team/$teamSlug/pair': typeof AuthenticatedTeamTeamSlugPairRoute
  '/team/$teamSlug/recents': typeof AuthenticatedTeamTeamSlugRecentsRoute
  '/canvas/$connId': typeof AuthenticatedCanvasConnIdIndexRoute
  '/team/$teamSlug': typeof AuthenticatedTeamTeamSlugIndexRoute
  '/team/$teamSlug/canvas': typeof AuthenticatedTeamTeamSlugCanvasIndexRoute
  '/team/$teamSlug/canvas/$connId/query': typeof AuthenticatedTeamTeamSlugCanvasConnIdQueryRoute
  '/team/$teamSlug/canvas/$connId': typeof AuthenticatedTeamTeamSlugCanvasConnIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_authenticated/pair': typeof AuthenticatedPairRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/team/$teamSlug': typeof AuthenticatedTeamTeamSlugRouteWithChildren
  '/_authenticated/canvas/$connId/query': typeof AuthenticatedCanvasConnIdQueryRoute
  '/_authenticated/team/$teamSlug/drafts': typeof AuthenticatedTeamTeamSlugDraftsRoute
  '/_authenticated/team/$teamSlug/pair': typeof AuthenticatedTeamTeamSlugPairRoute
  '/_authenticated/team/$teamSlug/recents': typeof AuthenticatedTeamTeamSlugRecentsRoute
  '/_authenticated/canvas/$connId/': typeof AuthenticatedCanvasConnIdIndexRoute
  '/_authenticated/team/$teamSlug/': typeof AuthenticatedTeamTeamSlugIndexRoute
  '/_authenticated/team/$teamSlug/canvas/': typeof AuthenticatedTeamTeamSlugCanvasIndexRoute
  '/_authenticated/team/$teamSlug/canvas/$connId/query': typeof AuthenticatedTeamTeamSlugCanvasConnIdQueryRoute
  '/_authenticated/team/$teamSlug/canvas/$connId/': typeof AuthenticatedTeamTeamSlugCanvasConnIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/pair'
    | '/'
    | '/team/$teamSlug'
    | '/canvas/$connId/query'
    | '/team/$teamSlug/drafts'
    | '/team/$teamSlug/pair'
    | '/team/$teamSlug/recents'
    | '/canvas/$connId'
    | '/team/$teamSlug/'
    | '/team/$teamSlug/canvas'
    | '/team/$teamSlug/canvas/$connId/query'
    | '/team/$teamSlug/canvas/$connId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/pair'
    | '/'
    | '/canvas/$connId/query'
    | '/team/$teamSlug/drafts'
    | '/team/$teamSlug/pair'
    | '/team/$teamSlug/recents'
    | '/canvas/$connId'
    | '/team/$teamSlug'
    | '/team/$teamSlug/canvas'
    | '/team/$teamSlug/canvas/$connId/query'
    | '/team/$teamSlug/canvas/$connId'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/signup'
    | '/_auth/verify-email'
    | '/_authenticated/pair'
    | '/_authenticated/'
    | '/_authenticated/team/$teamSlug'
    | '/_authenticated/canvas/$connId/query'
    | '/_authenticated/team/$teamSlug/drafts'
    | '/_authenticated/team/$teamSlug/pair'
    | '/_authenticated/team/$teamSlug/recents'
    | '/_authenticated/canvas/$connId/'
    | '/_authenticated/team/$teamSlug/'
    | '/_authenticated/team/$teamSlug/canvas/'
    | '/_authenticated/team/$teamSlug/canvas/$connId/query'
    | '/_authenticated/team/$teamSlug/canvas/$connId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pair': {
      id: '/_authenticated/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof AuthenticatedPairRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/team/$teamSlug': {
      id: '/_authenticated/team/$teamSlug'
      path: '/team/$teamSlug'
      fullPath: '/team/$teamSlug'
      preLoaderRoute: typeof AuthenticatedTeamTeamSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team/$teamSlug/': {
      id: '/_authenticated/team/$teamSlug/'
      path: '/'
      fullPath: '/team/$teamSlug/'
      preLoaderRoute: typeof AuthenticatedTeamTeamSlugIndexRouteImport
      parentRoute: typeof AuthenticatedTeamTeamSlugRoute
    }
    '/_authenticated/canvas/$connId/': {
      id: '/_authenticated/canvas/$connId/'
      path: '/canvas/$connId'
      fullPath: '/canvas/$connId'
      preLoaderRoute: typeof AuthenticatedCanvasConnIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team/$teamSlug/recents': {
      id: '/_authenticated/team/$teamSlug/recents'
      path: '/recents'
      fullPath: '/team/$teamSlug/recents'
      preLoaderRoute: typeof AuthenticatedTeamTeamSlugRecentsRouteImport
      parentRoute: typeof AuthenticatedTeamTeamSlugRoute
    }
    '/_authenticated/team/$teamSlug/pair': {
      id: '/_authenticated/team/$teamSlug/pair'
      path: '/pair'
      fullPath: '/team/$teamSlug/pair'
      preLoaderRoute: typeof AuthenticatedTeamTeamSlugPairRouteImport
      parentRoute: typeof AuthenticatedTeamTeamSlugRoute
    }
    '/_authenticated/team/$teamSlug/drafts': {
      id: '/_authenticated/team/$teamSlug/drafts'
      path: '/drafts'
      fullPath: '/team/$teamSlug/drafts'
      preLoaderRoute: typeof AuthenticatedTeamTeamSlugDraftsRouteImport
      parentRoute: typeof AuthenticatedTeamTeamSlugRoute
    }
    '/_authenticated/canvas/$connId/query': {
      id: '/_authenticated/canvas/$connId/query'
      path: '/canvas/$connId/query'
      fullPath: '/canvas/$connId/query'
      preLoaderRoute: typeof AuthenticatedCanvasConnIdQueryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team/$teamSlug/canvas/': {
      id: '/_authenticated/team/$teamSlug/canvas/'
      path: '/canvas'
      fullPath: '/team/$teamSlug/canvas'
      preLoaderRoute: typeof AuthenticatedTeamTeamSlugCanvasIndexRouteImport
      parentRoute: typeof AuthenticatedTeamTeamSlugRoute
    }
    '/_authenticated/team/$teamSlug/canvas/$connId/': {
      id: '/_authenticated/team/$teamSlug/canvas/$connId/'
      path: '/canvas/$connId'
      fullPath: '/team/$teamSlug/canvas/$connId'
      preLoaderRoute: typeof AuthenticatedTeamTeamSlugCanvasConnIdIndexRouteImport
      parentRoute: typeof AuthenticatedTeamTeamSlugRoute
    }
    '/_authenticated/team/$teamSlug/canvas/$connId/query': {
      id: '/_authenticated/team/$teamSlug/canvas/$connId/query'
      path: '/canvas/$connId/query'
      fullPath: '/team/$teamSlug/canvas/$connId/query'
      preLoaderRoute: typeof AuthenticatedTeamTeamSlugCanvasConnIdQueryRouteImport
      parentRoute: typeof AuthenticatedTeamTeamSlugRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedTeamTeamSlugRouteChildren {
  AuthenticatedTeamTeamSlugDraftsRoute: typeof AuthenticatedTeamTeamSlugDraftsRoute
  AuthenticatedTeamTeamSlugPairRoute: typeof AuthenticatedTeamTeamSlugPairRoute
  AuthenticatedTeamTeamSlugRecentsRoute: typeof AuthenticatedTeamTeamSlugRecentsRoute
  AuthenticatedTeamTeamSlugIndexRoute: typeof AuthenticatedTeamTeamSlugIndexRoute
  AuthenticatedTeamTeamSlugCanvasIndexRoute: typeof AuthenticatedTeamTeamSlugCanvasIndexRoute
  AuthenticatedTeamTeamSlugCanvasConnIdQueryRoute: typeof AuthenticatedTeamTeamSlugCanvasConnIdQueryRoute
  AuthenticatedTeamTeamSlugCanvasConnIdIndexRoute: typeof AuthenticatedTeamTeamSlugCanvasConnIdIndexRoute
}

const AuthenticatedTeamTeamSlugRouteChildren: AuthenticatedTeamTeamSlugRouteChildren =
  {
    AuthenticatedTeamTeamSlugDraftsRoute: AuthenticatedTeamTeamSlugDraftsRoute,
    AuthenticatedTeamTeamSlugPairRoute: AuthenticatedTeamTeamSlugPairRoute,
    AuthenticatedTeamTeamSlugRecentsRoute:
      AuthenticatedTeamTeamSlugRecentsRoute,
    AuthenticatedTeamTeamSlugIndexRoute: AuthenticatedTeamTeamSlugIndexRoute,
    AuthenticatedTeamTeamSlugCanvasIndexRoute:
      AuthenticatedTeamTeamSlugCanvasIndexRoute,
    AuthenticatedTeamTeamSlugCanvasConnIdQueryRoute:
      AuthenticatedTeamTeamSlugCanvasConnIdQueryRoute,
    AuthenticatedTeamTeamSlugCanvasConnIdIndexRoute:
      AuthenticatedTeamTeamSlugCanvasConnIdIndexRoute,
  }

const AuthenticatedTeamTeamSlugRouteWithChildren =
  AuthenticatedTeamTeamSlugRoute._addFileChildren(
    AuthenticatedTeamTeamSlugRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedPairRoute: typeof AuthenticatedPairRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedTeamTeamSlugRoute: typeof AuthenticatedTeamTeamSlugRouteWithChildren
  AuthenticatedCanvasConnIdQueryRoute: typeof AuthenticatedCanvasConnIdQueryRoute
  AuthenticatedCanvasConnIdIndexRoute: typeof AuthenticatedCanvasConnIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedPairRoute: AuthenticatedPairRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedTeamTeamSlugRoute: AuthenticatedTeamTeamSlugRouteWithChildren,
  AuthenticatedCanvasConnIdQueryRoute: AuthenticatedCanvasConnIdQueryRoute,
  AuthenticatedCanvasConnIdIndexRoute: AuthenticatedCanvasConnIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
